<template>
  <q-dialog v-model="Show" persistent @hide="CerrarModal">
    <q-card style="width: 650px; max-width: 90vw;" class="rounded-borders shadow-4">
      <q-card-section class="bg-primary text-white row items-center justify-between q-py-sm">
        <div class="text-h6 text-weight-bold row items-center">
          <q-icon name="add_circle" class="q-mr-sm" size="sm" />
          Nuevo Servicio de Empresa
        </div>
        <q-btn icon="close" flat round dense v-close-popup @click="CerrarModal" />
      </q-card-section>

      <q-card-section class="q-pa-md q-gutter-y-md">
        <q-input
          v-model="empresaDisplay"
          label="Empresa (RUC)"
          outlined
          dense
          disable
        />

        <q-select
          v-model="Servicio.idServicio"
          :options="ListaServicio"
          option-value="idServicio"
          option-label="descripcion"
          emit-value
          map-options
          label="Servicio *"
          outlined
          dense
        />

        <q-input
          v-model="Servicio.descripcion"
          label="Descripción Breve"
          outlined
          dense
        />

        <div class="row q-col-gutter-md">
          <div class="col-12 col-sm-4">
            <q-select
              v-model="Servicio.propio"
              :options="[
                { label: 'SÍ', value: 'SI' },
                { label: 'NO', value: 'NO' }
              ]"
              option-value="value"
              option-label="label"
              emit-value
              map-options
              label="Servicio de Aveo"
              outlined
              dense
            />
          </div>

          <div class="col-12 col-sm-4">
            <q-select
              v-model="Servicio.estado"
              :options="[
                { label: 'Vigente', value: 'V' },
                { label: 'Anulado', value: 'A' }
              ]"
              option-value="value"
              option-label="label"
              emit-value
              map-options
              label="Estado"
              outlined
              dense
            />
          </div>

          <div class="col-12 col-sm-4">
            <q-input
              v-model.number="Servicio.diasaviso"
              type="number"
              label="Días de Aviso"
              outlined
              dense
            />
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-pa-md bg-grey-1">
        <q-btn
          flat
          label="Cancelar"
          color="grey-7"
          no-caps
          @click="CerrarModal"
        />
        <q-btn
          color="primary"
          label="Guardar Servicio"
          icon="save"
          unelevated
          no-caps
          :loading="isLoading"
          :disable="EstadoBoton"
          class="text-weight-bold"
          @click="GuardarServicio"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "EmpresaServicioNuevoModal",
  props: {
    DialogServicio: {
      type: Boolean,
      required: true,
      default: false,
    },
    Servicio: {
      type: Object,
      required: false,
      default: () => ({
        ruc: "",
        idServicio: "",
        estado: "V",
        diasaviso: 5,
        descripcion: "",
        propio: "SI",
      }),
    },
  },
  data() {
    return {
      isLoading: false,
      Show: this.DialogServicio,
      EstadoBoton: false,
      localRuc: this.Servicio ? this.Servicio.ruc : "",
      ListaArticulos: [],
      ListaServicio: [],
    };
  },
  computed: {
    empresaDisplay() {
      const ruc = this.Servicio ? this.Servicio.ruc : this.localRuc;
      const empresa = this.ListaArticulos.find(
        (item) => item.ruc === ruc
      );
      return empresa
        ? `${ruc} - ${empresa.descripcion}`
        : ruc || "";
    },
  },
  watch: {
    DialogServicio(newVal) {
      this.Show = newVal;
      if (newVal) {
        this.GetServicios();
        this.GetEmpresas();
      }
    },
  },
  created() {
    if (this.DialogServicio) {
      this.GetEmpresas();
      this.GetServicios();
    }
  },
  methods: {
    async GetEmpresas() {
      try {
        const response = await axios.post("ApiWeb/EmpresaListaCombo.php");
        this.ListaArticulos = response.data.data || [];
      } catch (error) {
        console.error("Error GetEmpresas:", error);
      }
    },
    async GetServicios() {
      try {
        this.isLoading = true;
        const response = await axios.post("ApiWeb/ServicioListaCombo.php");
        this.ListaServicio = response.data.data || [];
      } catch (error) {
        console.error("Error GetServicios:", error);
        this.notificar("Error al cargar servicios", "warning");
      } finally {
        this.isLoading = false;
      }
    },
    GuardarServicio() {
      if (!this.Servicio.idServicio) {
        this.notificar("Seleccione un servicio", "warning");
        return;
      }

      this.isLoading = true;
      this.EstadoBoton = true;
      axios.post("ApiWeb/EmpresaServicioNuevo.php", this.Servicio)
        .then((response) => {
          if (response.data.error) {
            this.notificar(response.data.mensaje, "warning");
          } else {
            this.notificar(response.data.mensaje || "Servicio guardado exitosamente", "positive");
            this.CerrarModal();
          }
        })
        .catch((error) => console.error("Error GuardarServicio:", error))
        .finally(() => {
          this.isLoading = false;
          this.EstadoBoton = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000
        });
      } else {
        alert(msg);
      }
    },
    CerrarModal() {
      this.Show = false;
      this.$emit("CerrarModal");
    },
  },
};
</script>
